module.exports = __webpack_public_path__ + "img/additional-savings-red-round-gif.ed72aac7.gif";